import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import SVG from "./outline/like.svg";
var LikeOutline_default = forwardRef(
  (props, ref) => /* @__PURE__ */ jsx(SVG, { ref, ...props })
);
export {
  LikeOutline_default as default
};
